/**
 * @desc 查询列表-与我相关
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** baseCode */
  baseCode?: string;
  /** baseId */
  baseId?: string;
  /** endTime */
  endTime?: string;
  /** factoryCode */
  factoryCode?: string;
  /** findBy */
  findBy?: number;
  /** name */
  name?: string;
  /** page */
  page?: number;
  /** professionalId */
  professionalId?: number;
  /** sectionId */
  sectionId?: string;
  /** size */
  size?: number;
  /** startTime */
  startTime?: string;
  /** state */
  state?: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.Page<defs.EventListResponse>>> {
  return defHttp.get({
    url: '/wap/event/related_me',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.Page<defs.EventListResponse>>> {
  return defHttp.get({
    url: '/mock/wap/event/related_me',

    params,
  });
}
